export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14960.6dfa09b7.jpg";